<template>
    <spinner
        v-if="isLoadedStopListProductsWithoutFilter"
        :key="'spinner_loaded_stop_list_products_pagination'"
    />
    <div v-if="!isLoadedStopListProductsWithoutFilter" class="table_data__pagination">
        <pagination
            :key="'pagination'"
        />
    </div>
    <div v-if="!isLoadedStopListProductsWithoutFilter" class="table_data__list">
        <div class="table_data__list_items">
            <div class="table_data_item head">
                <div class="table_data_item_checkbox">
                    <checkbox_custom
                        :key="'checkbox_custom_head'"
                        :checkboxState="isCheckHead"
                        :checkboxBorderPrimaryColor="true"
                        @click_checkbox_custom="clickCheckboxHead"
                    />
                </div>
                <div class="table_data_item_market">
                    <div class="table_data_item_text">
                        {{ __t('O.MARKET') }}
                    </div>
                </div>
                <div class="table_data_item_image">
                    <div class="table_data_item_image_icon">
                        <font-awesome-icon icon="fa-regular fa-images"/>
                    </div>
                </div>
                <div class="table_data_item_product">
                    <div class="table_data_item_text">
                        {{ __t('O.PRODUCTS_TITLE') }}
                    </div>
                </div>
                <div class="table_data_item_restaurant">
                    <div class="table_data_item_text">
                        {{ __t('O.RESTAURANTS_TITLE') }}
                    </div>
                </div>
                <div class="table_data_item_location">
                    <div class="table_data_item_text">
                        {{ __t('O.LOCATIONS_TITLE') }}
                    </div>
                </div>
                <div class="table_data_item_added">
                    <div class="table_data_item_added_head">
                        <div class="table_data_item_added_head_text">
                            {{ __t('O.ADDED') }}
                        </div>
                        <div class="table_data_item_added_head_icon">

                        </div>
                    </div>
                </div>
                <div class="table_data_item_button">
                    <div class="table_data_item_button_head">
                        <font-awesome-icon icon="fa-solid fa-gear"/>
                    </div>
                </div>
            </div>

            <table_data_item
                v-for="item in stopListProductsWithoutFilter"
                :key="'table_data_item_' + item.id"
                :item="item"
                @click_button_stop_list="clickButtonStopList"
            />
        </div>
    </div>
</template>

<script>
import pagination from "./Pagination.vue";
import checkbox_custom from "../CheckboxCustom.vue";
import table_data_item from "./TableDataItem.vue";

import {createHelpers} from "vuex-map-fields";
import Spinner from "../loader/Spinner.vue";

const {mapFields: mStopList} = createHelpers({
    getterType: 'stop_list/getStopListField',
    mutationType: 'stop_list/updateStopListField',
})


export default {
    name: "table_data",
    props: {
        totalPagination: {
            type: Number,
            required: false,
            default: 0,
        },
        isShowFilter: {
            type: Boolean,
            required: true,
            default: false,
        }
    },
    components: {
        Spinner,
        checkbox_custom,
        pagination,
        table_data_item
    },
    emits: ['click_button_page'],
    data() {
        return {
            isCheckHead: false,
        }
    },
    methods: {
        clickCheckboxHead() {
            this.isCheckHead = !this.isCheckHead;
            this.stopListProductsWithoutFilter.forEach(item => item.isCheck = this.isCheckHead);
        },
        clickCheckboxItem(itemTab) {
            this.stopListProductsWithoutFilter.forEach(item => item.isCheck = item === itemTab);
        },
        clickButtonStopList(clickItem) {
            let products = [];
            this.stopListProductsWithoutFilter.forEach(item => {
                if(item.isCheck) {
                    products.push(item);
                }
            });
            if(!products.includes(clickItem)) {
                products.push(clickItem);
            }
            this.$store.dispatch('stop_list/STOP_LIST_PRODUCTS_ACTION',{
                actionName: 'stopListProductsAction',
                action: 'remove',
                products: products,
            })
        },
    },
    computed: {
        ...mStopList([
            'stopListProductsWithoutFilter',
            'isLoadedStopListProductsWithoutFilter',
            'filterStopList'
        ]),
        currentPage() {
            return this.filterStopList.activePage;
        }
    },
}
</script>
